// Recovered compiled webpack factory 60738. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { P: () => s });
  var n = i(99256);
  function s(t) {
    return t.props[n.n];
  }
}
